import { render, staticRenderFns } from "./removeCodebook.vue?vue&type=template&id=badd6298&scoped=true&lang=html&"
import script from "./removeCodebook.vue?vue&type=script&lang=js&"
export * from "./removeCodebook.vue?vue&type=script&lang=js&"
import style0 from "./removeCodebook.vue?vue&type=style&index=0&id=badd6298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badd6298",
  null
  
)

export default component.exports